/* ══════════════════════════════════════════════════════════════════════════
   RK · CARRUSELES HORIZONTALES
   ──────────────────────────────────────────────────────────────────────────
   Controlador único para cualquier riel con scroll horizontal del theme
   (productos destacados, tamaños de teclado, cualquier sección futura).

   Antes esto vivía dentro de featured-products.liquid y hacía
   querySelectorAll('[data-rail]') sobre todo el documento: si esa sección no
   estaba en la página, ningún otro riel tenía flechas. Ahora es un módulo.

   Contrato con el Liquid:
     [data-rail]        el contenedor que scrollea
     [data-rail-prev]   botón anterior  (dentro de la misma <section>)
     [data-rail-next]   botón siguiente (dentro de la misma <section>)

   El scroll nativo con snap sigue siendo la fuente de verdad: las flechas
   solo empujan. En celular no hay flechas y se arrastra con el dedo.
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function wire(rail) {
    /* Idempotente: el editor de temas re-renderiza secciones y este módulo
       vuelve a pasar por los mismos nodos. */
    if (rail.dataset.railReady === 'true') return;
    rail.dataset.railReady = 'true';

    var scope = rail.closest('section') || rail.parentElement;
    if (!scope) return;

    var prev = scope.querySelector('[data-rail-prev]');
    var next = scope.querySelector('[data-rail-next]');

    /* Un paso = el ancho real de una tarjeta más el gap. Se mide en vivo
       porque el ancho cambia con el breakpoint. */
    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      var atStart = rail.scrollLeft <= 2;
      var atEnd = rail.scrollLeft >= max;

      prev.disabled = atStart;
      next.disabled = atEnd;

      /* Si todo entra sin scroll, las flechas no aportan nada */
      var nav = prev.closest('[data-rail-nav]');
      if (nav) nav.hidden = rail.scrollWidth <= rail.clientWidth + 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rail]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.theme = window.theme || {};
  window.theme.initRails = init;
})();
